import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from 'redux';
import reduxThunk from 'redux-thunk';
import reducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(reduxThunk));
const createApplicationStore = () => {
  return createStore(reducer, enhancer);
};
const store = createApplicationStore();

// DEBUG
window.getAppState = () => {
  return store.getState();
};

export default store;
